import yaml from 'js-yaml';

import { DataContractYAML, ServerConfig } from '@/types/dataContracts';

/**
 * Safely parse YAML content and return a typed DataContractYAML object.
 * Returns null if parsing fails or content is undefined.
 */
export function parseDataContractYAML( yamlContent: string | undefined ): DataContractYAML | null {
  if ( !yamlContent ) return null;

  try {
    const parsed = yaml.load( yamlContent ) as DataContractYAML;
    return parsed;
  } catch( error ) {
    console.error( 'Failed to parse YAML:', error );
    return null;
  }
}

/**
 * Format server configuration into human-readable strings.
 * Returns an array of formatted key-value pairs.
 */
export function formatServerInfo( server: ServerConfig | undefined ): string[] {
  if ( !server ) return [];

  const info: string[] = [];
  if ( server.type ) info.push( `Type: ${ server.type }` );
  if ( server.host ) info.push( `Host: ${ server.host }` );
  if ( server.port ) info.push( `Port: ${ server.port }` );
  if ( server.database ) info.push( `Database: ${ server.database }` );
  if ( server.schema ) info.push( `Schema: ${ server.schema }` );

  return info;
}
